import * as React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import { visuallyHidden } from "@mui/utils";
import { jsPDF } from "jspdf"; //or use your library of choice here
import autoTable from "jspdf-autotable";
import { Download } from "@mui/icons-material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Collapse } from "@mui/material";
import { earlyWarning } from "../../earlyWarning/ShowEarlyWarning";

interface Data {
  w_id: string;
  w_desc: string;
  severity: string;
  w_status: string;
  adm3_en: string;
  issued_time: string;
  validityPeriod: string;
  en_desc: string;
  severity_index: string;
  active_alevel: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

interface HeadCell {
  [x: string]: any;
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  {
    id: "w_desc",
    numeric: false,
    disablePadding: false,
    label: "Warning Name",
  },
  {
    id: "severity",
    numeric: false,
    disablePadding: false,
    label: "Severity",
  },
  {
    id: "w_status",
    numeric: false,
    disablePadding: false,
    label: "Warning Status",
  },
  {
    id: "adm3_en",
    numeric: false,
    disablePadding: false,
    label: "Division",
  },
  {
    id: "issued_time",
    numeric: false,
    disablePadding: false,
    label: "Start Time",
  },
  {
    id: "validityPeriod",
    numeric: false,
    disablePadding: false,
    label: "End Time",
  },
];

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
             
              style={{ color: "white" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

interface EnhancedTableToolbarProps {
  numSelected: number;
  rows: any;
  tableTitle:string
}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
  const handleExportRows = () => {
    const doc = new jsPDF();
    const tableData = props.rows.map((row: Data) => Object.values(row));
    const tableHeaders = headCells.map((c) => c.label);

    autoTable(doc, {
      head: [tableHeaders],
      body: tableData,
    });

    doc.save("mrt-pdf-example.pdf");
  };
  const { numSelected } = props;

  const Titletable=(name:string):string =>{
    if(name==="Amber"){
      return "Warning";
    }else if(name==="Yellow"){
      return "Watch";
    }else if(name==="Red"){
      return "Evacuation";
    }
return "Warning";
  }

  return (
    <Toolbar
      sx={{
        /* pl: { sm: 2 },
        pr: { xs: 1, sm: 1 }, */
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {
        <Typography
          sx={{ flex: "1 1 100%", color: "white" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
Early Warning
        
        </Typography>
      }
      {
        <Tooltip title="Filter list">
          <IconButton onClick={() => handleExportRows()}  onTouchStart={() => handleExportRows()}>
            <Download />
          </IconButton>
        </Tooltip>
      }
    </Toolbar>
  );
}

interface EWSDataTableProps {
  earlyWarningsFromChild: earlyWarning[];
}
export const EWSDataTable: React.FC<EWSDataTableProps> = ({
  earlyWarningsFromChild,
}) => {
  const [tables, setTables] = React.useState<Array<any>>([]);
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("adm3_en");
  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [tableTitle,setTableTitle] = React.useState<string>("");
  const [searchQuery, setSearchQuery] = React.useState<string>(""); 

  const [expandedRowIndices, setExpandedRowIndices] = React.useState<number[]>(
    []
  );

  const handleRowClick = (tableIndex: number, rowIndex: number) => {
    setExpandedRowIndices((prev) => {
      // Create a copy of the current expanded state
      const newExpandedRowIndices = [...prev];
      const combinedIndex = tableIndex * 100 + rowIndex; // unique index for each table-row combo
      if (newExpandedRowIndices.includes(combinedIndex)) {
        // If already expanded, collapse it
        return newExpandedRowIndices.filter((index) => index !== combinedIndex);
      } else {
        // Expand it
        return [...newExpandedRowIndices, combinedIndex];
      }
    });
  };

  React.useEffect(() => {
    const result = earlyWarningsFromChild;
    if (result.length > 0) {
      // Remove duplicates based on the unique identifier (e.g., adm3_en)
      const formattedRows = result.map((warning: Data) => ({
        w_desc: warning.w_desc,
        severity: warning.severity,
        w_status: warning.w_status,
        adm3_en: warning.adm3_en,
        issued_time: warning.issued_time,
        validityPeriod: warning.validityPeriod,
        en_desc: warning.en_desc,
        severity_index: warning.severity_index,
        active_alevel: warning.active_alevel,
      }));

      setTables((prevTables) => {
        // Flatten previous tables and extract severities
        const existingSeverities = new Set(
          prevTables.flat().map((row) => row.severity)
        );
        // Filter out rows with duplicate severities
        const uniqueFormattedRows = formattedRows.filter(
          (row) => !existingSeverities.has(row.severity)
        );

        if (existingSeverities.size > 0) {
          const firstSeverity = Array.from(existingSeverities)[0];
          setTableTitle(firstSeverity);
        }
        // Only add unique rows
        return uniqueFormattedRows.length > 0
          ? [...prevTables, uniqueFormattedRows]
          : prevTables;
      });
    }
  }, [earlyWarningsFromChild]);

  React.useEffect(() => {},[tableTitle]);

  const severity_color: { [key: string]: string } = {
    Yellow: "#FFFF00",
    Amber: "#FFBF00",
    Red: "#FF0000",
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDense(event.target.checked);
  };

  
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page on search
  };

  const filteredRows = tables.filter((row: Data) => {
    const searchFields = `${row.w_desc} ${row.severity} ${row.w_status} ${row.adm3_en} ${row.issued_time} ${row.validityPeriod} ${row.en_desc} ${row.severity_index} ${row.active_alevel}`;
    return searchFields.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tables.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredRows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filteredRows]
  );

  return (
    <Box
      sx={{
        width: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      {tables.map((tableRows, tableIndex) => (
        <Paper
          key={tableIndex}
          sx={{
            width: "100%",
            backgroundColor: "rgba(255, 255, 255, 0)",
            mb: 3, // Add spacing between tables
          }}
        >
                <Box sx={{ padding: "16px", display: "flex", justifyContent: "flex-end" }}>
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              padding: "8px",
              width: "40%",
              borderRadius: "4px",
            }}
          />
        </Box>
          <EnhancedTableToolbar
            numSelected={selected.length}
            rows={tableRows}
            tableTitle={tableTitle}
          />
          <TableContainer>
            <Table
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={tableRows.length}
              />
              <TableBody>
                {tableRows.map((row: Data, index: number) => (
                  <React.Fragment key={index}>
                    <TableRow
                      hover
                      tabIndex={-1}
                      // key={index}
                      onClick={() => handleRowClick(tableIndex, index)}
                      onTouchStart={() => handleRowClick(tableIndex, index)}
                      sx={{
                        cursor: "pointer",
                        color: "var(--text-color)",
                        fontSize: "14px",
                      }}
                    >
                      <TableCell
                        style={{ color: "var(--text-color)" }}
                        align="left"
                      >
                        {row.w_desc}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "var(--text-color)" }}
                      >
                        <div
                          style={{
                            border: `1px solid ${
                              severity_color[row.severity as string] || "#000"
                            }`,
                            borderRadius: "10px",
                            color: "black",
                            fontWeight: "bold",
                            height: "30px",
                            backgroundColor: `${
                              severity_color[row.severity as string] || "#FFF"
                            }`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {row.severity}
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "var(--text-color)" }}
                      >
                        {row.w_status}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "var(--text-color)" }}
                      >
                        {row.adm3_en}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "var(--text-color)" }}
                      >
                        {row.issued_time}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ color: "var(--text-color)" }}
                      >
                        {row.validityPeriod}
                      </TableCell>
                    </TableRow>
                    {expandedRowIndices.includes(tableIndex * 100 + index) && (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          style={{
                            paddingLeft: "30px",
                            color: "var(--text-color)",
                          }}
                        >
                          <div>
                            <strong>Description:</strong> {row.en_desc}
                          </div>
                          <div>
                            <strong>Severity Index:</strong>
                            {row.severity_index}
                          </div>
                          <div>
                            <strong>Active Level:</strong> {row.active_alevel}
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={tableRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{ color: "var(--text-color)" }}
          />
        </Paper>
      ))}
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
        style={{ color: "var(--text-color)" }}
      />
    </Box>
  );
};
